<template>
   <div class="user-data-block">
        <!-- Блок с фото пользователя -->
        <div class="user-photo-block">
            <img 
                v-if="userPhotoUrl" 
                :src="userPhotoUrl" 
                alt="User Photo" 
                class="user-photo"
                @error="handleImageError"
            >
            <div v-else class="no-photo">
                <div class="photo-placeholder">📷</div>
                <span class="no-photo-text">Фото не найдено</span>
            </div>
            <div class="blur-user-name">{{ first_name }}</div>
        </div>

        <!-- Блок со статусом дропа -->
        <div class="drop-status-block">
            <div class="drop-status-label">Статус: </div>
            <div class="drop-status-value">COMING <br>SOON</div>
        </div>

        <!-- Челвечик (символ TheBestMarket) -->
        <img src="../assets/images-templates/дорисовано-Photoroom.png" alt="Человечек #TBM" class="tbm-man">
   </div> 
</template>

<script>
export default {
    name: 'UserPhotoBlock',
    
    data() {
        return {
            userPhotoUrl: null,
            first_name: null
        };
    },

    methods: {
        // Основная функция для получения photo_url из localStorage
        getUserPhotoUrl() {
            try {
                // Пытаемся получить photo_url напрямую из localStorage
                const photoUrl = localStorage.getItem('photo_url');
                
                if (photoUrl) {
                    this.userPhotoUrl = photoUrl;
                    console.log('Фото получено из localStorage:', photoUrl);
                    return;
                }



                // Если photo_url нет напрямую, ищем в объекте user_data
                const userDataString = localStorage.getItem('user_data');
                if (userDataString) {
                    const userData = JSON.parse(userDataString);
                    if (userData.photo_url) {
                        this.userPhotoUrl = userData.photo_url;
                        console.log('Фото получено из user_data:', userData.photo_url);
                        return;
                    }
                }

                console.log('Фото не найдено в localStorage');
                this.userPhotoUrl = null;

            } catch (error) {
                console.error('Ошибка при получении фото из localStorage:', error);
                this.userPhotoUrl = null;
            }
        },
        
        // Функция для получения first_name из localStorage
        getFirstName() {
            try {
                // 1. Прямо из localStorage
                const firstName = localStorage.getItem('first_name');
                if (firstName) {
                    this.first_name = firstName;
                    return;
                }

                // 2. Из объекта user_data
                const userDataString = localStorage.getItem('user_data');
                if (userDataString) {
                    const userData = JSON.parse(userDataString);
                    if (userData.first_name) {
                        this.first_name = userData.first_name;
                        return;
                    }
                    if (userData.user_name) {
                        this.first_name = userData.user_name;
                        return;
                    }
                }

                // 3. Значение по умолчанию
                this.first_name = 'Пользователь';

            } catch (error) {
                console.error('Ошибка при получении имени:', error);
                this.first_name = 'Пользователь';
            }
        },

        // Обработчик ошибки загрузки изображения
        handleImageError(event) {
            console.warn('Ошибка загрузки изображения');
            this.userPhotoUrl = null;
            
            // Скрываем сломанное изображение
            event.target.style.display = 'none';
        },

        // Функция для принудительного обновления фото
        refreshPhoto() {
            this.getUserPhotoUrl();
        }
    },

    mounted() {
        this.getUserPhotoUrl();
        this.getFirstName();
    },

    // Опционально: можно следить за изменениями в localStorage
    created() {
        // Слушаем изменения localStorage из других вкладок
        window.addEventListener('storage', (event) => {
            if (event.key === 'photo_url' || event.key === 'user_data') {
                console.log('Обнаружено изменение в localStorage, обновляем фото');
                this.getUserPhotoUrl();
            }
        });
    }
}
</script>

<style>
.user-data-block {
    font-family: 'CentureGothic', sans-serif;
    display: flex;
    /* align-items: center; */
    height: 40vw;
    width: 100%;
    background-color: rgba(255, 255, 255, 0.08);
    padding: 2vw;
    border-radius: 10px;
    position: relative;
    gap: 2vw;
}

.user-photo-block {
    position: relative;
}

.user-photo {
    height: 34vw;
    width: 34vw;
    border-radius: 10px;
}

.blur-user-name {
    color: white;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 8vw;
    display: flex;
    align-items: center; 
    justify-content: center;
    font-size: 10px;
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    background-color: rgba(0, 0, 0, .3);
    border-radius: 0 0 10px 10px;
}

.tbm-man {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 30vw;
    height: auto;
}

.drop-status-block {
    display: flex;
    gap: 1vw;
    font-size: 18px;
    font-weight: 800;
    line-height: 20px;
}

.drop-status-label {
    color: white;
}

.drop-status-value {
    color: #005ADA;
    font-size: 20px;
}
</style>